import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import PropTypes from 'prop-types';
import tr from '../../../libs/tr'
import './style.css';

/**
 * This component renders a list of pairs of values in a two-columns tabular way.
 * Additionally a 'totals' row is rendered, with a label and the sum of the list of the elements values.
 */
class List extends Component {

  constructor(props) {
    super(props);
    console.log('List props:', props);
    this.state = {
      totalLabel: props.totalLabel ? props.totalLabel : tr.t("Total"),
      totalValue: 0,
      locale: props.locale ? props.locale : 'it-IT',
      currency: props.currency ? props.currency : 'EUR',
    }
  }

  componentWillMount() {
    this.setState({totalValue: this.sum(this.props.elements)});
  }

  componentWillReceiveProps(nextProps) {
    const { elements } = nextProps;
    if (JSON.stringify(elements) != JSON.stringify(this.props.elements)) {
      this.setState({totalValue: this.sum(elements)});
    }
  }

  sum(elements) {
    let totalValue = 0;
    elements.map((element, index) => {
      //console.log('List sum element:', element, index);
      let value = element[1];
        if (Number(value)) {
          totalValue += parseFloat(value);
      }
    });
    return totalValue;
  }

  formatCurrency(number) {
    return parseFloat(number).toLocaleString(this.state.locale, { style: 'currency', currency: this.state.currency });
  }
  
  render() {
    return (
      <Container style={this.props.styleContainer}>
        {this.props.elements.map((element, index) => {
          //console.log('List element:', element, index);
          if (element[1] !== false) { // ignore elements with a second value as false
            return (
              <Row key={index} className={this.props.styleRow}>
                <Col xs="8" style={{textAlign:'left'}}>{element[0]}</Col>
                <Col xs="4" style={{textAlign:'right'}}>{this.formatCurrency(element[1])}</Col>
              </Row>
            );
          }
        })}
        <hr style={{borderWidth: 1, borderColor: 'white'}} />
        <Row className={this.props.styleRow + ' ' + this.props.styleRowTotal}>
          <Col xs="8" style={{textAlign:'left', fontWeight:'bold'}}>{this.state.totalLabel}</Col>
          <Col xs="4" style={{textAlign:'right', fontWeight:'bold'}}>{this.formatCurrency(this.state.totalValue)}</Col>
        </Row>
      </Container>
    );
  }
}

List.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.array).isRequired,
}

export default List;



// WEBPACK FOOTER //
// ./src/assets/components/list/index.js